module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/ic_info-8334158ab1da3e03cec4d3c1f36c0ddc.svg";